export const TENANT = {
  user: 'user',
  staff: 'staff',
} as const

export type Tenancy = (typeof TENANT)[keyof typeof TENANT]
